export default __webpack_public_path__ + "static/media/TwoPeople.7c6098a2.svg";